import type { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';

export interface StatisticCardProps {
  value: string;
  label: string;
  icon: ReactElement;
  color: string;
}

/** One cell of the floating glass statistics card: a small tinted icon, a big value and a label. */
export default function StatisticCard({ value, label, icon, color }: StatisticCardProps) {
  return (
    <Box sx={{ flex: '1 1 0', px: { xs: 1.5, lg: 2.25 }, py: 1.75, minWidth: 0 }}>
      <Box
        sx={{
          width: 30,
          height: 30,
          borderRadius: 1.75,
          display: 'grid',
          placeItems: 'center',
          mb: 1,
          bgcolor: `${color}22`,
          border: `1px solid ${color}55`,
          '& svg': { fontSize: 17, color },
        }}
      >
        {icon}
      </Box>
      <Typography sx={{ fontWeight: 800, fontSize: { xs: 19, lg: 22 }, color: '#fff', lineHeight: 1.1, letterSpacing: '-0.01em' }}>
        {value}
      </Typography>
      <Typography sx={{ fontSize: 12, color: 'rgba(203,213,225,0.7)', mt: 0.25 }}>{label}</Typography>
    </Box>
  );
}
